import { render, staticRenderFns } from "./ItemGroupCreateView.vue?vue&type=template&id=1b5a64ba"
import script from "./ItemGroupCreateView.vue?vue&type=script&lang=js"
export * from "./ItemGroupCreateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports